import type { TourConfig } from '../types';

export const adminReportsPageTour: TourConfig = {
  pageId: 'admin-reports',
  pageName: 'All Reports',
  portalId: 'crm',
  steps: [
    {
      element: '[data-tour="admin-report-filters"]',
      title: 'Report Filters',
      intro:
        'Select business, report type (by referral source, rep, or aging), date range, and commission status to scope your report.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
    {
      element: '[data-tour="admin-report-export"]',
      title: 'Export',
      intro:
        'Click "Export CSV" to download the generated report data as a spreadsheet file.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
    {
      element: '[data-tour="admin-report-table"]',
      title: 'Report Table',
      intro:
        'View detailed project-level data including revenue, rep commission, partner commission, and payment status.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
  ],
};
